import IRedirectUrl from "@/module/main/dto/IRedirectUrl";

export default class RedirectUrl implements IRedirectUrl {
    constructor(public gatewayRedirectUrl: string) {
    }
}
